"use strict";

/**
 * Изменение параметров контейнера календарь
 *
 * todo разделить? вынести создание нового контейнера в другое место
 * todo удалить большое количество копи-паста
 */
(function(){

Fotobook.containers.calendar.editor = {

    changeAlignment($container, verticalAlign, align) {
        let containerId = parseInt($container.attr("data-id"), 10);

        return Fotobook.containers.changeContainerAttrs({
            [containerId] : {
                "calendar" : {
                    "numbers_align" : align,
                    "numbers_vertical_align" : verticalAlign,
                },
            },
        });
    },

    /** Показать/скрыть дни недели */
    changeDayNamesPosition: function($container, show){
        var params = {},
            value = show ? Fotobook.containers.calendar.SHOW_BEFORE : Fotobook.containers.calendar.SHOW_NONE,
            id = parseInt($container.attr("data-id"), 10);

        params[id] = {
            "calendar" : {
                "day_names_position" : value,
            },
        };
        return Fotobook.containers.changeContainerAttrs(params);
    },

    setCalendarDate: function ($container, month, year) {
        let id = parseInt($container.attr("data-id"), 10),
            date = (new Date(year, month, 1)).toNormalizedDateString();

        Fotobook.containers.changeContainerAttrs({
            [id] : {
                "calendar_date" : date,
            },
        }).then(() => {
            $(".cont_"+id).attr("data-calendar_date", date);
        }).catch(() => {});
    },

};


})();
